<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-textarea
          outlined
          auto-grow
          label="Observações"
          counter="1000"
          rows="2"
          v-model="contratacao.observacao"
        >
          <template v-slot:append-outer>
            <px-anexo v-model="contratacao.arquivos"
                      :max="5"
                      :upload-base-path="uploadFilePath"
                      @loading="onFileLoad">
            </px-anexo>
          </template>
        </v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    contratacao: Object,
  },
  computed: {
    uploadFilePath() {
      return this.$pxFrete.uploadFilePath;
    },
  },
  methods: {
    onFileLoad(loading) {
      this.hasFileLoading = loading;
    },
  },
};
</script>
